exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._5nQr6FJY59mZvxsfqBJ0Y{display:flex;border-bottom:1px solid #dedede}._5nQr6FJY59mZvxsfqBJ0Y h1,._5nQr6FJY59mZvxsfqBJ0Y h2,._5nQr6FJY59mZvxsfqBJ0Y h3,._5nQr6FJY59mZvxsfqBJ0Y h4,._5nQr6FJY59mZvxsfqBJ0Y h5,._5nQr6FJY59mZvxsfqBJ0Y h6{text-transform:none;line-height:1}._1FXcqQL3AQlt021ojsH_px{flex:1;min-width:0;padding:40px 2em 2em 2em;background:#f5f5f5}._1FXcqQL3AQlt021ojsH_px pre ._2rbqcxwzNdtGfAoOr24r7m{white-space:pre-wrap;width:100%;height:100px}._1oey9XDTyYqRtMucMWk4SW{flex:2;min-width:0;margin:40px 100px 100px 15px}\n", ""]);

// Exports
exports.locals = {
	"EmbedConfigurator": "_5nQr6FJY59mZvxsfqBJ0Y",
	"LeftPanel": "_1FXcqQL3AQlt021ojsH_px",
	"embedCode": "_2rbqcxwzNdtGfAoOr24r7m",
	"Preview": "_1oey9XDTyYqRtMucMWk4SW"
};